<template>
  <!--
          作者：kmdshop
          时间：2023-06-30
          描述：插件中心-短信群发-发送任务
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="query">查询</el-button>
    </div>
    <div class="common-level-rail" style="margin-top: 20px;">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="add">添加</el-button>
      
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="lapply_id" label="应用ID" width="70"></el-table-column>
            <el-table-column prop="name" label="应用名称" width="100"></el-table-column>
            <el-table-column prop="code" label="应用编码" width="100"></el-table-column>
            <el-table-column prop="code_upper" label="应用编码大小写" width="100"></el-table-column>
            
            <el-table-column prop="version" label="应用版本" width="100"></el-table-column>
            <el-table-column prop="use.text" label="是否使用" width="100"></el-table-column>

            <el-table-column prop="create_time" label="添加时间" ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="gen(scope.row)" type="text" size="small">生成应用</el-button>  
                <el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>  
                <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>  
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <Add
    v-if="open_add"
    :open_add="open_add"
    @closeDialog="closeDialog('add')"
  ></Add>

  <Edit
    v-if="open_edit"
    :open_edit="open_edit"
    :model="item"
    @closeDialog="closeDialog('edit')"
  ></Edit>
  </div>
</template>
<script>
  import LapplyApi from '@/api/lapply.js';
  import Add from "./add.vue";
  import Edit from "./edit.vue";
  export default {
    components:{
      Add,
      Edit
   },
    data() {
      return {
        formInline: {},
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,

        open_add:false,
        open_edit:false,
        item:{}
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      gen(item){
        let self = this;
        let Params = {};

        Params = item
        LapplyApi.gen({
          "parmas":JSON.stringify(Params)
        }, true)
          .then(data => {
            self.loading = false;
            self.$message({
                message: data.msg,
                type: 'success'
              });
          })
          .catch(error => {});
      },
      query(){
        this.getData();
      },
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.limit = {
          page : self.curPage,
          list_rows : self.pageSize,
        }
        LapplyApi.index(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
      /*添加*/
      add() {
        this.open_add = true;
      },
      /*修改*/
      edit(e) {
        let self = this;
        e.use = e.use.value
        this.item = e;
        this.open_edit = true;
      },
      /*删除*/
      del(e) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 并且表，文件都会一并删除，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.loading = true;
          LapplyApi.del({
            lapply_id: e.lapply_id
            }, true).then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();

            })
            .catch(error => {
              self.loading = false;
            });

        }).catch(() => {
          self.loading = false;
        });
      },
       /* 关闭编辑框 */
      closeDialog(type) {
          if(type == 'add'){
              this.open_add = false;
          }else{
              this.open_edit = false;
          }
         
          this.getData()
      },

    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/lapply/index/index.vue